import React, { Component } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import API from "../utils/api";

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(props.location ? props.location.search : "");
    this.state = {
      identifier: params.get("identifier") || "",
      otp: "",
      newPassword: "",
      confirmPassword: "",
      loading: false,
      done: false,
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { identifier, otp, newPassword, confirmPassword } = this.state;
    if (!identifier || !otp || !newPassword) {
      return toast.error("All fields are required");
    }
    if (newPassword !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    this.setState({ loading: true });
    try {
      await API.post("/auth/reset-password", { identifier, otp, newPassword });
      toast.success("Password reset successfully");
      this.setState({ done: true });
    } catch (err) {
      const msg =
        err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "Failed to reset password";
      toast.error(msg);
    }
    this.setState({ loading: false });
  };

  render() {
    const { identifier, otp, newPassword, confirmPassword, loading, done } = this.state;

    return (
      <div className="login-wrapper">
        <div className="login-box">
          <h2>
            <i className="fas fa-lock"></i> Reset Password
          </h2>
          {done ? (
            <div>
              <p>Your password has been reset. You can now log in.</p>
              <Link to="/login" className="btn btn-primary btn-block">
                Go to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Email or Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="identifier"
                  value={identifier}
                  onChange={this.handleChange}
                  placeholder="Enter your email or mobile"
                  required
                />
              </div>
              <div className="form-group">
                <label>OTP</label>
                <input
                  type="text"
                  className="form-control"
                  name="otp"
                  value={otp}
                  onChange={this.handleChange}
                  placeholder="Enter the OTP sent to you"
                  required
                />
              </div>
              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handleChange}
                  placeholder="Enter new password"
                  required
                />
              </div>
              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this.handleChange}
                  placeholder="Confirm new password"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? (
                  <span>
                    <i className="fas fa-spinner fa-spin"></i> Resetting...
                  </span>
                ) : (
                  "Reset Password"
                )}
              </button>
            </form>
          )}
          <div className="text-center" style={{ marginTop: 12 }}>
            <Link to="/login">Back to login</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPasswordPage;
